import { User } from "features/User/models";
import { compactText, escapeHtml } from "./html";

export default function generateSlackAuthorizationMessage(user: User | undefined): string {
  const accountSettingsUrl = `${window.location.origin}/account/settings`;

  return compactText(`
    <p>Hi ${escapeHtml(user?.firstName || "there")},</p>
    <p>You have messages scheduled to be sent on your behalf in Camino, but you haven't authorized Camino in Slack yet.</p>
    <p>To authorize:</p>
    <ul>
      <li>Go to your profile settings in Camino: <a href="${escapeHtml(accountSettingsUrl)}">${escapeHtml(accountSettingsUrl)}</a></li>
      <li>Connect your Slack account and grant message permissions</li>
    </ul>
    <p>Once authorized, your scheduled messages will be sent automatically.</p>
    <p>Thanks!</p>
  `);
}
